var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkdxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 620,
    viewBox: "0 0 620 620",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-skdx-logo",
    x1: -0.028,
    y1: -0.028,
    x2: 0.859,
    y2: 0.859,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#416991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262c58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00b8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_113197",
    "data-name": "Group 113197",
    transform: "translate(1861.177 -1071.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113116",
    "data-name": "Group 113116",
    transform: "translate(-1861.177 1071.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112606",
    "data-name": "Group 112606",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17671",
    "data-name": "Ellipse 17671",
    cx: 310,
    cy: 310,
    r: 310,
    fill: "url(#linear-gradient-skdx-logo)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_143464",
    "data-name": "Path 143464",
    d: "M-1381.687,1495.784l-15.83-15.84-34.919-34.934,34.919-34.94,15.83-15.828,15.833,15.828,34.915,34.94-34.915,34.934Zm0,48.959v104.4l-151.958-151.958,52.218-52.192Zm-151.957-151.916v104.362l52.218-52.192,99.74-99.726V1240.859Z",
    transform: "translate(1740.614 -1134.038)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_113117",
    "data-name": "Group 113117",
    transform: "translate(-1830.102 1102.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143829",
    "data-name": "Path 143829",
    d: "M-1520.085,1678.921h-25.306l.007-25.293h25.293Zm-82.759-8.549-12.088-3.716a279.825,279.825,0,0,1-115.023-69.267,279.83,279.83,0,0,1-69.454-114.9l-3.735-12.082,24.164-7.471,3.737,12.081a254.429,254.429,0,0,0,63.159,104.469,254.42,254.42,0,0,0,104.582,62.989l12.089,3.715Zm140.217-.079-7.458-24.168,12.084-3.729a254.443,254.443,0,0,0,104.506-63.1,254.424,254.424,0,0,0,63.046-104.544l3.723-12.086,24.172,7.444-3.721,12.086a279.807,279.807,0,0,1-69.33,114.98,279.816,279.816,0,0,1-114.938,69.392Zm-349.185-257.342v-25.306h25.293v25.3Zm557.848-.3h-25.293v-25.9l25.293-.006Zm-525.156-75.039-24.18-7.416,3.708-12.091a279.816,279.816,0,0,1,69.2-115.065,279.848,279.848,0,0,1,114.854-69.516l12.08-3.743,7.486,24.161-12.08,3.743a254.458,254.458,0,0,0-104.431,63.216,254.438,254.438,0,0,0-62.933,104.62Zm492.252-.833-3.75-12.078a254.444,254.444,0,0,0-63.272-104.392,254.423,254.423,0,0,0-104.657-62.876l-12.094-3.7,7.4-24.186,12.093,3.7a279.8,279.8,0,0,1,115.106,69.142,279.84,279.84,0,0,1,69.578,114.813l3.749,12.078Zm-233.817-190.411h-25.3l-.006-25.293h25.306Z",
    transform: "translate(1811.813 -1121.074)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkdxLogo);
export default __webpack_public_path__ + "static/media/skdx-logo.df8f8645765992f978a7599bc488dddc.svg";
export { ForwardRef as ReactComponent };